<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br><hr>
<chart [data]="chart.data" [options]="chart.options" [sextant]="'zonesChart'"></chart>

<br><br>

<loading [isLoad]="loader"></loading>
<table *ngIf="!loader" class="table" [sextant]="'zonesTable'">
	<thead>
		<tr>
			<th>{{ 'adminstat.billing.domain_zones.domain zone' | translate }}</th>
			<th>{{ 'adminstat.billing.domain_zones.paid' | translate }}</th>
			<th>{{ 'adminstat.billing.domain_zones.prolongated' | translate }}</th>
			<th>{{ 'adminstat.billing.domain_zones.expired' | translate }}</th>
		</tr>
	</thead>
	
	<tbody>
		<tr *ngFor="let stat of stats">
			<td>{{ stat.zone }}</td>
			
			<td>
				<button-anhor *ngIf="stat.total > 0; else other" (click)="showDetails(stat.zone, 'total')">
					{{ stat.total }}
				</button-anhor>

				<ng-template #other>
					0
				</ng-template>
			</td>
			
			<td>
				<button-anhor *ngIf="stat.renew > 0; else other" (click)="showDetails(stat.zone, 'renew')">
					{{ stat.renew }}
				</button-anhor>
				({{ (stat.renew / stat.total * 100).toFixed(1) }}%)

				<ng-template #other>
					0
				</ng-template>
			</td>
			
			<td>
				<button-anhor *ngIf="stat.expired > 0; else other" (click)="showDetails(stat.zone, 'expired')">
					{{ stat.expired }}
				</button-anhor>
				({{ (stat.expired / stat.total * 100).toFixed(1) }}%)

				<ng-template #other>
					0
				</ng-template>
			</td>
		</tr>
	</tbody>
</table>
